import React from 'react';
import { Link } from 'react-router-dom';
import { Recommender } from '../types';

interface RecommenderCardProps {
  person: Recommender;
}

const RecommenderCard: React.FC<RecommenderCardProps> = ({ person }) => {
  // Guard against empty parts (e.g. a double space in a display name) so the
  // initials don't include `undefined` — matches the detail pages' handling.
  const initials = person.name
    .split(' ')
    .map((n) => n[0] ?? '')
    .join('');

  return (
    <Link
      to={`/recommenders/${person.slug}`}
      className="group card card-hover block p-8"
    >
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-amber/20 to-terracotta/20 border border-amber/30 flex items-center justify-center">
          <span className="text-amber font-display text-xl">{initials}</span>
        </div>
        <div>
          <h2 className="font-display text-xl text-charcoal group-hover:text-amber transition-colors duration-300">
            {person.name}
          </h2>
        </div>
      </div>

      {/* Restaurant List */}
      <div className="space-y-3">
        {person.restaurants.map((restaurant) => (
          <div key={restaurant.rank} className="flex items-baseline gap-3">
            <span className={`font-display text-lg ${
              restaurant.rank === 1 ? 'text-amber' : 'text-charcoal/30'
            }`}>
              {restaurant.rank}
            </span>
            <p className={`text-sm ${
              restaurant.rank === 1 ? 'text-charcoal' : 'text-charcoal-light'
            }`}>
              {restaurant.name}
            </p>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="mt-8 pt-6 border-t border-black/5 flex items-center justify-between">
        <span className="text-xs text-charcoal-light uppercase tracking-wider">View picks</span>
        <svg
          className="w-4 h-4 text-charcoal-light group-hover:text-amber group-hover:translate-x-1 transition-all duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </div>
    </Link>
  );
};

export default RecommenderCard;
